import React, {useEffect, useState, useRef} from "react";
import {CargarPlanes, CargarPlan} from "./CargarPlanes";
import { CargarItemsPlan, CargarItemsPlanesDB } from './CargarItemsPlan';

import { Stepper, Step, StepLabel, Menu, TextField, CircularProgress } from '@mui/material';
import {Input} from '@mui/material';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from "@mui/material";
import Button from '@mui/material/Button';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import UndoIcon from '@mui/icons-material/Undo';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

import { CheckCircleOutline } from '@mui/icons-material';
import logotexto from './../assets/images/logotipo.jpg'

import Switch from '@mui/material/Switch';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import zustand from 'zustand';
import CotizadorStore from "../store/cotizador";
import useStore from "../store/cotizador";
import Planes from "../types/Planes";
import PrecioConFormato from "./PrecioConFormato";
import ContadorItems from "./ContadorItems";

import ordenarIntegrantes from "../functions/OrdenarIntegrantes";

import EnviarCorreoValidacion from "../functions/EnviarCorreoValidacion";
import EnviarSMSValidacion from "../functions/EnviarSMSValidacion";
import UsarCodigoValidacion from "../functions/UsarCodigoValidacion";

import SuscripcionMP  from "../functions/SuscripcionMP";
import PagoMP from "../functions/PagoMP";

import InsertarSociosPendientePago from "../functions/InsertarSociosPendientePago";
import VerificarSociosInsertados from "../functions/VerificarSociosInsertados";
import VerificarSocio from "../functions/VerificarSocio";

import { initMercadoPago, Payment, CardPayment, Wallet } from '@mercadopago/sdk-react';
import InsertarInteresados from "../functions/InsertarInteresados";

import SeleccionarPais from './SeleccionarPais';
import SeleccionarProvincia from './SeleccionarProvincia';
import SeleccionarLocalidad from './SeleccionarLocalidad';

import PaisSeleccionar from '../types/PaisSeleccionar';
import ProvinciaSeleccionar from '../types/ProvinciaSeleccionar';
import LocalidadSeleccionar from '../types/LocalidadSeleccionar';
import Integrante from "../types/Integrante";

import DatePicker from "./DatePicker";
import ObtenerAgenteComercial from "../functions/ObtenerAgenteComercial";

import TerminosYCondiciones from "../data/TerminosYCondiciones";

import EnviarCorreoBienvenida from "../functions/EnviarCorreoBienvenida";
import EnviarCorreoBienvenidaCoordinarPago from "../functions/EnviarCorreoBienvenidaCoordinarPago";

/*
initMercadoPago('APP_USR-bc519733-ac2e-4af4-b679-9eeb78d91b7c',{
    locale: "es-AR",
});
*/

// Public Key de Mercado Pago - Secure
initMercadoPago('APP_USR-d8eadbed-b0f1-486e-82bd-fbf6369ae06c',{
    locale: "es-AR",
});

interface EmailGrupoFamiliar {
    documento: string;
    apellido: string;
    nombres: string;
    email: string;
    celular: string;
    fecnac: string;
    tipoIntegrante: "" | "Titular" | "Conyuge" | "Menor" | "Mayor";
};

const CotizadorPasoAPaso: React.FC<{navegacionFija: boolean, id: string, pasos: string[], paso: number, setpaso (paso: number): void }> = ({navegacionFija, id, pasos, paso, setpaso }) => {

    const ReferenciaGenerada = useRef(false);

    // Traigo las variables de estado del store
    const estadoCotizador = useStore();
    const {pasoActual, setPasoActual, incrementarPaso, decrementarPaso} = CotizadorStore();
    const {reiniciarCotizador} = CotizadorStore();
    const {titular, setTitular} = CotizadorStore();
    const {conyuge, setConyuge} = CotizadorStore();
    const {hijos, setHijos} = CotizadorStore();
    const {cantidadHijos, setCantidadHijos} = CotizadorStore();
    const {mayores, setMayores} = CotizadorStore();
    const {cantidadMayores, setCantidadMayores} = CotizadorStore();
    const {idPlan, setIdPlan} = CotizadorStore();
    const {importeNormal, setImporteNormal} = CotizadorStore();
    const {importeDebito, setImporteDebito} = CotizadorStore();
    const {importeAnual, setImporteAnual} = CotizadorStore();
    const {importeTotal, setImporteTotal} = CotizadorStore();
    const {importeNormalMenor, setImporteNormalMenor} = CotizadorStore();
    const {importeNormalMayor, setImporteNormalMayor} = CotizadorStore();
    const {importeDebitoMenor, setImporteDebitoMenor} = CotizadorStore();
    const {importeDebitoMayor, setImporteDebitoMayor} = CotizadorStore();
    const {importeAnualMenor, setImporteAnualMenor} = CotizadorStore();
    const {importeAnualMayor, setImporteAnualMayor} = CotizadorStore();
    const {cantidadIntegrantes, setCantidadIntegrantes} = CotizadorStore();
    
    const {modo, setModo} = CotizadorStore();
    const {formaPago, setFormaPago} = CotizadorStore();
    const {porcentajeDescuento, setPorcentajeDescuento} = CotizadorStore();
    const {nombrePlan, setNombrePlan} = CotizadorStore();
    const {descripcionPlan, setDescripcionPlan} = CotizadorStore();
    const {cantidadMaximaConyuge, setCantidadMaximaConyuge} = CotizadorStore();
    const {cantidadMaximaMenores, setCantidadMaximaMenores} = CotizadorStore();
    const {cantidadMaximaMayores, setCantidadMaximaMayores} = CotizadorStore();
    const {datosIntegranteOk, setDatosIntegranteOk} = CotizadorStore();

    // Variables locales para el estado del cotizador
    const [planes, setPlanes] = useState([] as Planes[]);
    const [cantidadIntegrantesLocal, setCantidadIntegrantesLocal] = useState(1);
    const [itemsplanesData, setItemsPlanesData] = useState<any[]>([]);

    const [maxedadtitular, setMaxEdadTitular] = useState(0);
    const [maxedadconyuge, setMaxEdadConyuge] = useState(0);
    const [maxedadmenor, setMaxEdadMenor] = useState(0);
    const [maxedadmayor, setMaxEdadMayor] = useState(0);

    //const itemsplanesData = CargarItemsPlan();
    //const itemsplanesData = CargarItemsPlanesDB();

    // Para el paso 01 -> Carga del grupo familiar
    const {cantidadIntegrantesCargados, setCantidadIntegrantesCargados} = CotizadorStore();
    const {idActual, setIdActual} = CotizadorStore();
    const {documentoActual, setDocumentoActual} = CotizadorStore();
    const {nombresActual, setNombresActual} = CotizadorStore();
    const {apellidoActual, setApellidoActual} = CotizadorStore();
    //const {fechaNacimientoActual, setFechaNacimientoActual} = CotizadorStore();
    const {fechaNacimientoActual, setFechaNacimientoActual} = CotizadorStore();
    
    const [localFechaNacimientoValida, setLocalFechaNacimientoValida] = useState(false);
    
    const {sexoActual, setSexoActual} = CotizadorStore();
    const {emailActual, setEmailActual} = CotizadorStore();
    const {celularActual, setCelularActual} = CotizadorStore();
    const {tipoActual, setTipoActual} = CotizadorStore();
    const {documentoActualError, setDocumentoActualError} = CotizadorStore();
    const {nombresActualError} = CotizadorStore();
    const {apellidoActualError} = CotizadorStore();
    const {fechaNacimientoActualError} = CotizadorStore();
    const {emailActualError} = CotizadorStore();
    const {celularActualError} = CotizadorStore();
    
    const {solicitarEmail, setSolicitarEmail} = CotizadorStore();
    const {solicitarCelular, setSolicitarCelular} = CotizadorStore();
    const {validarEmail, setValidarEmail} = CotizadorStore();
    const {validarCelular, setValidarCelular} = CotizadorStore();
    const {pagoOnline, setPagoOnline} = CotizadorStore();
    const {datosGuardados, setDatosGuardados} = CotizadorStore();

    const {paisActual, setPaisActual} = CotizadorStore();
    const {provinciaActual, setProvinciaActual} = CotizadorStore();
    const {localidadActual, setLocalidadActual} = CotizadorStore();
    const {domicilioActual, setDomicilioActual} = CotizadorStore();
    const {domicilioActualError, setDomicilioActualError} = CotizadorStore();

    const {cuilActual, setCuilActual} = CotizadorStore();
    const {cuilActualError, setCuilActualError} = CotizadorStore();

    const {reiniciarCamposActual} = CotizadorStore();
    const {incrementarIdActual} = CotizadorStore();
    const {recorrerIntegrantes} = CotizadorStore();
    const {hayError, setHayError} = CotizadorStore();
    
    const {integrantes, agregarIntegrante, eliminarIntegrante, actualizarReferenciaIntegrantes} = CotizadorStore();
    let integrantesOrdenados = ordenarIntegrantes(integrantes);
    
    const {titularCargado, setTitularCargado} = CotizadorStore();
    const {conyugeCargado, setConyugeCargado} = CotizadorStore();
    const {cantidadHijosCargados, setCantidadHijosCargados} = CotizadorStore();
    const {cantidadMayoresCargados, setCantidadMayoresCargados} = CotizadorStore();

    const [editando, setEditando] = useState(false);
    const [idEditando, setIdEditando] = useState(-1);
    const [eliminando, setEliminando] = useState(false);
    const [idEliminando, setIdEliminando] = useState(-1);
    const [socioExiste, setSocioExiste] = useState(false);
    const [interesadosInsertados, setInteresadosInsertados] = useState(false);
    
    // Para el paso 02 -> Validación de datos de contacto
    const [enviandoEmail, setEnviandoEmail] = useState(false);
    const [enviandoSMS, setEnviandoSMS] = useState(false);
    const [emailEnviado, setEmailEnviado] = useState(false);
    const [smsEnviado, setSMSEnviado] = useState(false);
    const [emailValidado, setEmailValidado] = useState(false);
    const [celularValidado, setCelularValidado] = useState(false);
    const [errorEmail, setErrorEmail] = useState('');
    const [errorSMS, setErrorSMS] = useState('');
    const [errorValidarEmail, setErrorValidarEmail] = useState('');
    const [errorValidarSMS, setErrorValidarSMS] = useState('');

    const [codigoEmail, setCodigoEmail] = useState('');
    const [codigoSMS, setCodigoSMS] = useState('');
    
    const [codigoAgente, setCodigoAgente] = useState('');
    const [codigoAgenteError, setCodigoAgenteError] = useState(false);
    const [mensajeErrorCA, setMensajeErrorCA] = useState('');
    const [nombreAgenteComercial, setNombreAgenteComercial] = useState('');
    const [aceptaTerminos, setAceptaTerminos] = useState(false);
    const [verTerminos, setVerTerminos] = useState(false);
    const [scroll, setScroll] = React.useState<DialogProps['scroll']>('paper');
    const [terminosYCondiciones, setTerminosYCondiciones] = useState('');

    const {getEmail} = CotizadorStore();
    const {getCelular} = CotizadorStore();
    const {getTitular} = CotizadorStore();
    const [elTitular, setElTitular] = useState({ id: -1, documento: '', apellido: '', nombres: '', fechaNacimiento: '', sexo: 'Masc.', email: '', celular: '', tipo: '', pais: 1, provincia: 1, localidad: 1, domicilio: '' });
    const [elEmail, setElEmail] = useState('');
    const [elCelular, setElCelular] = useState('');

    // Para el paso 03 -> Pago online por mercadopago
    const [formularioPagoIsLoading, setFormularioPagoIsLoading] = useState(true);
    const [laSuscripcionMP, setLaSuscripcionMP] = useState<{id?: string; init_point?: string; back_url?: string, referencia?: string} | null>(null);
    const [pagoRealizado, setPagoRealizado] = useState(false);
    const [pagoError, setPagoError] = useState(false);
    const [pagoErrorMessage, setPagoErrorMessage] = useState('');
    const [sociosInsertados, setSociosInsertados] = useState(false);
    const [resultadoValidarGuardadoSocios, setResultadoValidarGuardadoSocios] = useState<{sociosInsertados: number; sociosValidados: boolean; correoBienvenidaEnviado: boolean} | null>(null);
    
    //const [valorPlan, setValorPlan] = useState(0);
    //const [idPlan, setIdPlan] = useState('-1');

    // Variables de estado para el grupo familiar
    //const [titular, setTitular] = useState(true);
    //const [conyuge, setConyuge] = useState(false);
    //const [hijos, setHijos] = useState(false);
    //const [mayores, setMayores] = useState(false);

    // No se muestra el importe en la parte superior del formulario
    // Si se quiere mostrar, cambiar este valor a 1.
    //const mostrarImporteSuperior = 0;

    // Método para reiniciar las edades máximas al cambiar de plan
    const reiniciarEdadesMaximas = () => {
        setMaxEdadTitular(0);
        setMaxEdadConyuge(0);
        setMaxEdadMenor(0);
    };

    const handleNext = async () => {
        
        if (pasoActual === 2) {
            if (!interesadosInsertados) {
                const interesados = await InsertarInteresados(integrantesOrdenados, codigoAgente, idPlan);
                if (interesados.mensaje === 'ok') {
                    setInteresadosInsertados(true);
                }
            }
        }
        incrementarPaso();        
    };
  
    const handleBack = () => {
        decrementarPaso();
    };
  
    const handleHome = () => {
        window.location.href = 'https://www.vidaplus.com.ar';
    }

    const handleChange = (event: SelectChangeEvent) => {
        const nuevoValor = event.target.value as string;
        setIdPlan(parseInt(nuevoValor));

        const elPlanSeleccionado = planes.filter(plan => plan.id === parseInt(nuevoValor));
      
        if (elPlanSeleccionado && elPlanSeleccionado.length > 0) {
            setImporteNormal(elPlanSeleccionado[0].price);
            setImporteDebito(elPlanSeleccionado[0].pricedebito);
            setImporteAnual(elPlanSeleccionado[0].priceanual);
            setImporteNormalMenor(elPlanSeleccionado[0].pricemenor);
            setImporteNormalMayor(elPlanSeleccionado[0].pricemayor);
            setImporteDebitoMenor(elPlanSeleccionado[0].pricedebitomenor);
            setImporteDebitoMayor(elPlanSeleccionado[0].pricedebitomayor);
            setImporteAnualMenor(elPlanSeleccionado[0].priceanualmenor);
            setImporteAnualMayor(elPlanSeleccionado[0].priceanualmayor);
            setNombrePlan(elPlanSeleccionado[0].title);
            setDescripcionPlan(elPlanSeleccionado[0].description);
            setCantidadMaximaConyuge(elPlanSeleccionado[0].maxconyuge);
            setCantidadMaximaMenores(elPlanSeleccionado[0].maxmenores);
            setCantidadMaximaMayores(elPlanSeleccionado[0].maxmayores);
            setMaxEdadTitular(elPlanSeleccionado[0].maxedadtitular);
            setMaxEdadConyuge(elPlanSeleccionado[0].maxedadconyuge);
            setMaxEdadMenor(elPlanSeleccionado[0].maxedadmenor);
            setMaxEdadMayor(elPlanSeleccionado[0].maxedadmayor);
            setSolicitarCelular(elPlanSeleccionado[0].sol_celu);
            setValidarCelular(elPlanSeleccionado[0].val_celu);
            setSolicitarEmail(elPlanSeleccionado[0].sol_email);
            setValidarEmail(elPlanSeleccionado[0].val_email);
            setPagoOnline(elPlanSeleccionado[0].pago_online);
        } else {
            setImporteNormal(0);
            setImporteDebito(0);
            setImporteAnual(0);
            setImporteNormalMenor(0);
            setImporteNormalMayor(0);
            setImporteDebitoMenor(0);
            setImporteDebitoMayor(0);
            setImporteAnualMenor(0);
            setImporteAnualMayor(0);
            setNombrePlan('');
            setDescripcionPlan('');
            setCantidadMaximaConyuge(0);
            setCantidadMaximaMenores(0);
            setCantidadMaximaMayores(0);
            reiniciarEdadesMaximas();
            setSolicitarCelular('N');
            setSolicitarEmail('N');
            setValidarCelular('N');
            setValidarEmail('N');
            setPagoOnline('N');
        }
    };

    const handleChangeTitular = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTitular(event.target.checked);
    };

    const handleChangeConyuge = (event: React.ChangeEvent<HTMLInputElement>) => {
        setConyuge(event.target.checked);
        if (event.target.checked) {
            setCantidadIntegrantes(cantidadIntegrantes + 1);
        } else {
            setCantidadIntegrantes(cantidadIntegrantes - 1);
        }
    };

    const setCantidadConyugeLocal = (cantidad: number) => {
        if (cantidad === 1) {
            setConyuge(true);
            setCantidadIntegrantes(cantidadIntegrantes + 1);
        } else {
            setConyuge(false);
            setCantidadIntegrantes(cantidadIntegrantes - 1);
        }
    };

    const handleChangeHijos = (event: React.ChangeEvent<HTMLInputElement>) => {
        setHijos(event.target.checked);
        if (event.target.checked) {
            setCantidadHijos(1);
        } else {
            setCantidadHijos(0);
        }
    };

    const setCantidadHijosLocal = (prmCantidad: number) => {
        if (prmCantidad === 0) {
            setHijos(false);
        } else {
            setHijos(true);
        }
        setCantidadHijos(prmCantidad);
    };

    const handleChangeMayores = (event: React.ChangeEvent<HTMLInputElement>) => {
        setMayores(event.target.checked);
        if (event.target.checked) {
            setCantidadMayores(1);
        } else {
            setCantidadMayores(0);
        }
    };

    const handleChangeModalidad = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            setModo('año');
            setFormaPago('deb/cred');
        } else {
            setModo('mes');
        }
    };

    const handleChangeFormaPago = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            setFormaPago('deb/cred');
        } else {
            setFormaPago('efectivo');
            setModo('mes');
        }
    };
    
    const setCantidadMayoresLocal = (prmCantidad: number) => {
        if (prmCantidad === 0) {
            setMayores(false);
        } else {
            setMayores(true);
        }
        setCantidadMayores(prmCantidad);
    };

    const reiniciarFormulario = () => {
        if (editando) {
            setEditando(false);
        }
        if (eliminando) {
            setEliminando(false);
        }
        setEmailEnviado(false);
        setSMSEnviado(false);
        setEmailValidado(false);
        setCelularValidado(false);
        setCodigoEmail('');
        setCodigoSMS('');
        setEnviandoEmail(false);
        setEnviandoSMS(false);
        setCodigoAgente('');
        setCodigoAgenteError(false);
        setMensajeErrorCA('');
        setPagoRealizado(false);
        setPagoError(false);
        setPagoErrorMessage('');
        reiniciarCotizador();
        setSolicitarCelular('N');
        setSolicitarEmail('N');
        setValidarCelular('N');
        setValidarEmail('N');
        setPagoOnline('N');
    };

    const handleBtnReiniciar = () => {
        reiniciarCamposActual();
        if (editando) {
            setEditando(false);
        }
        if (eliminando) {
            setEliminando(false);
        }
        const campoDocumento = document.getElementById('documento') as HTMLInputElement;
        campoDocumento.focus();
    };

    // Para datepicker
    const checkFechaNacIsValid = (isValid: boolean) => {
        setLocalFechaNacimientoValida(isValid);
    };

    const handleBtnAgregarIntegrante = async () => {
        if (!hayError) {
            if (!editando && !eliminando) {

                // Antes de agregarlo, verifico si ya existe un integrante con el mismo documento en el arreglo de integrantes o en la base de datos
                // Primero busco en el arreglo de integrantes con some. Si existe alguno devuelve true, sino false.
                const integranteExistente = integrantes.some(integrante => integrante.documento === documentoActual);
                
                const socioVerificado = await VerificarSocio(documentoActual);

                if (integranteExistente || (socioVerificado.socios_existentes !== 0)) {
                    //console.log(socioVerificado.mensaje, socioVerificado.socios_existentes);
                    setSocioExiste(true);
                } else {

                    setSocioExiste(false);

                    // Agregando un integrante
                    const nuevoIntegrante = {
                        id: idActual,
                        documento: documentoActual,
                        nombres: nombresActual,
                        apellido: apellidoActual,
                        fechaNacimiento: fechaNacimientoActual,
                        sexo: sexoActual,
                        email: emailActual,
                        celular: celularActual,
                        tipo: tipoActual,
                        pais: paisActual,
                        provincia: provinciaActual,
                        localidad: localidadActual,
                        domicilio: domicilioActual,
                        cuil: cuilActual,
                        pago_pendiente: 'S',
                        referencia: ''
                    };
                    agregarIntegrante(nuevoIntegrante);
                    setCantidadIntegrantesCargados(cantidadIntegrantesCargados + 1);
                    if (tipoActual === 'Titular') {
                        setTitularCargado(true);
                    }
                    if (tipoActual === 'Conyuge') {
                        setConyugeCargado(true);
                    }
                    if (tipoActual === 'Menor') {
                        setCantidadHijosCargados(cantidadHijosCargados + 1);
                    }
                    if (tipoActual === 'Mayor') {
                        setCantidadMayoresCargados(cantidadMayoresCargados + 1);
                    }                
                    reiniciarCamposActual();
                    incrementarIdActual();
                }
            } else {
                if (editando) {
                    // Editando un integrante
                    const integranteEditado = {
                        id: idActual,
                        documento: documentoActual,
                        nombres: nombresActual,
                        apellido: apellidoActual,
                        fechaNacimiento: fechaNacimientoActual,
                        sexo: sexoActual,
                        email: emailActual,
                        celular: celularActual,
                        tipo: tipoActual,
                        pais: paisActual,
                        provincia: provinciaActual,
                        localidad: localidadActual,
                        domicilio: domicilioActual,
                        cuil: cuilActual,
                        pago_pendiente: 'S',
                        referencia: ''
                    };
                    eliminarIntegrante(idEditando);
                    agregarIntegrante(integranteEditado);
                    setEditando(false);
                    setIdEditando(-1);
                } else {
                    // Eliminando un integrante
                    eliminarIntegrante(idEliminando);
                    setEliminando(false);
                    setIdEliminando(-1);
                }
                recorrerIntegrantes();
            }
        }
    };

    const editarIntegrante = (id: number) => {
        return () => {
            const integrante = integrantes.find(integrante => integrante.id === id);
            if (integrante) {
                setIdActual(integrante.id);
                setDocumentoActual(integrante.documento);
                setNombresActual(integrante.nombres);
                setApellidoActual(integrante.apellido);
                setSexoActual(integrante.sexo);
                setEmailActual(integrante.email);
                setCelularActual(integrante.celular);
                setTipoActual(integrante.tipo);
                let maxEdad = 0;
                if (integrante.tipo === 'Titular') { maxEdad = maxedadtitular; }
                if (integrante.tipo === 'Conyuge') { maxEdad = maxedadconyuge; }
                if (integrante.tipo === 'Menor') { maxEdad = maxedadmenor; }
                if (integrante.tipo === 'Mayor') { maxEdad = maxedadmayor; }
                setFechaNacimientoActual(integrante.fechaNacimiento, maxEdad);
                setDomicilioActual(integrante.domicilio);
                setCuilActual(integrante.cuil);
                setEditando(true);
                setIdEditando(id);
            }
        };
    };

    const eliminarIntegranteLocal = (id: number) => {
        return () => {
            const integrante = integrantes.find(integrante => integrante.id === id);
            if (integrante) {
                setIdActual(integrante.id);
                setDocumentoActual(integrante.documento);
                setNombresActual(integrante.nombres);
                setApellidoActual(integrante.apellido);
                setSexoActual(integrante.sexo);
                setEmailActual(integrante.email);
                setCelularActual(integrante.celular);
                setTipoActual(integrante.tipo);
                let maxEdad = 0;
                if (integrante.tipo === 'Titular') { maxEdad = maxedadtitular; }
                if (integrante.tipo === 'Conyuge') { maxEdad = maxedadconyuge; }
                if (integrante.tipo === 'Menor') { maxEdad = maxedadmenor; }
                if (integrante.tipo === 'Mayor') { maxEdad = maxedadmayor; }
                setFechaNacimientoActual(integrante.fechaNacimiento, maxEdad);
                setDomicilioActual(integrante.domicilio);
                setCuilActual(integrante.cuil);
                setEliminando(true);
                setIdEliminando(id);
            }
        };
    };

    const validarCodigoEmail = async (codigo: string) => {
        const patron = /^[0-9]{0,6}$/;
        if (patron.test(codigo.trim())) setCodigoEmail(codigo);
        if (codigo.trim().length === 6 && patron.test(codigo.trim())) {
            // El código es numérico y tiene 6 caracteres
            UsarCodigoValidacion(elTitular.documento, elTitular.apellido.trim() + ", " + elTitular.nombres.trim(), elTitular.email, elTitular.celular, 'email', codigo)
            .then(resultado => {
                if (resultado.mensaje === 'ok' && resultado.codigo_validado === "si") {
                    setEmailEnviado(true);
                    setEmailValidado(true);
                    setErrorValidarEmail('');
                } else {
                    setEmailEnviado(true);
                    setEmailValidado(false);
                    setErrorValidarEmail(resultado.mensaje);
                }
            })
            .catch(error => {
                setEmailEnviado(true);
                setEmailValidado(false);
                setErrorValidarEmail(error);
            });
        }
    };

    const validarCodigoSMS = async (codigo: string) => {
        const patron = /^[0-9]{0,6}$/;
        if (patron.test(codigo.trim())) setCodigoSMS(codigo);
        if (codigo.trim().length === 6 && patron.test(codigo.trim())) {
            // El código es numérico y tiene 6 caracteres
            UsarCodigoValidacion(elTitular.documento, elTitular.apellido.trim() + ", " + elTitular.nombres.trim(), elTitular.email, elTitular.celular, 'sms', codigo)
            .then(resultado => {
                if (resultado.mensaje === 'ok' && resultado.codigo_validado === "si") {
                    setSMSEnviado(true);
                    setCelularValidado(true);
                    setErrorValidarSMS('');
                } else {
                    setSMSEnviado(true);
                    setCelularValidado(false);
                    setErrorValidarSMS(resultado.mensaje);
                }
            })
            .catch(error => {
                setSMSEnviado(true);
                setCelularValidado(false);
                setErrorValidarSMS(error);
            });
        }
    };

    const validarCodigoAgente = async (codigo: string) => {
        //const patron = /^[0-9]{0,5}$/;
        setCodigoAgente(codigo.toUpperCase());
        
        //console.log("Codigo: ", codigo);
        
        if (codigo.trim().length <= 8)
        {
            try {
                const resultado = await ObtenerAgenteComercial(codigo.trim(),0);
                if (resultado.agentecomercial_ok === 'si') {
                    setCodigoAgenteError(false);
                    setMensajeErrorCA('');
                    setNombreAgenteComercial(resultado.agentecomercial[0].apellido.trim() + ", " + resultado.agentecomercial[0].nombres.trim());
                } else {
                    setNombreAgenteComercial('');
                    setCodigoAgenteError(true);
                    setMensajeErrorCA('Código de Agente Comercial no Válido.');
                }
            } catch (error) {
                setNombreAgenteComercial('');
                setCodigoAgenteError(true);
                setMensajeErrorCA('Error al verificar el Código de Agente Comercial.');
            }
        } else {
            setCodigoAgenteError(true);
            setMensajeErrorCA('Código No Válido. Se esperan 8 dígitos / caracteres.');
        }
    };

    const handleChangeTerminos = (event: React.ChangeEvent<HTMLInputElement>) => {
        setAceptaTerminos(event.target.checked);
    };

    const handleCerrarTerminos = () => {
        setVerTerminos(false);
    };

/*    const handleClickOpen = (scrollType: DialogProps['scroll']) => () => {
        setVerTerminos(true);
        setScroll(scrollType);
      };
*/
    const handleClickVerTerminos = () => {
        setVerTerminos(true);
    };

    const reiniciarCodigoAgente = () => {
        setCodigoAgente('');
        setCodigoAgenteError(false);
        setMensajeErrorCA('');
    };
    const onReady = async () => {
        setFormularioPagoIsLoading(false);
    };

    const handleRealizarPago = () => {
        console.log("Realizando el pago...");
        console.log("La suscripción de Mercado Pago es: ", laSuscripcionMP);
        if (laSuscripcionMP && laSuscripcionMP.init_point) {
            window.location.replace(laSuscripcionMP.init_point);
        }
    };

    const handleEsperarContactoComercial = () => {
        setPasoActual(4);
    }
    
    // Métodos para actualizar Pais - Provincia - Localidad
    const handlePaisChange = (paisSeleccionado: PaisSeleccionar) => {
        setPaisActual(paisSeleccionado.id);
    }

    const handlePaisClear = () => {
        setPaisActual(0);
    }

    const handleProvinciaChange = (provinciaSeleccionada: ProvinciaSeleccionar) => {
        setProvinciaActual(provinciaSeleccionada.id);
    }

    const handleProvinciaClear = () => {
        setProvinciaActual(0);
    }

    const handleLocalidadChange = (localidadSeleccionada: LocalidadSeleccionar) => {
        setLocalidadActual(localidadSeleccionada.id);
    }

    const handleLocalidadClear = () => {
        setLocalidadActual(0);
    }
    
    const handleFechaNacimientoChange = (fecha: string) => {
        let maxEdad = 0;
        if (tipoActual === 'Titular') { maxEdad = maxedadtitular; }
        if (tipoActual === 'Conyuge') { maxEdad = maxedadconyuge; }
        if (tipoActual === 'Menor') { maxEdad = maxedadmenor; }
        if (tipoActual === 'Mayor') { maxEdad = maxedadmayor; }
        if (fecha !== fechaNacimientoActual) setFechaNacimientoActual(fecha, maxEdad);
    };

    /*
    useEffect(() => {
        const fetchPlanes = async () => {
            setPlanes(await CargarPlanes());
        }

        fetchPlanes();
    }, []);
    */
   useEffect(() => {
        const fetchPlanes = async () => {
            try {
                const planes = await CargarPlanes();

                // filtramos solo los que tengan mostrar = "S" o "C"
                const planesFiltrados = planes.filter((p: { mostrar: string }) => p.mostrar === "S" || p.mostrar === "C");

                setPlanes(planesFiltrados);
            } catch (error) {
                console.error("Error cargando planes:", error);
            }
        };

        fetchPlanes();
    }, []);

     useEffect(() => {
        const titularYConyuge = (titular ? 1 : 0) + (conyuge ? 1 : 0);
        const cantMayores = (mayores ? cantidadMayores : 0);
        const cantMenores = hijos ? cantidadHijos : 0;

        if (modo === 'mes') {
            // Pago mensual
            if (formaPago === 'efectivo') {
                const total = importeNormal * titularYConyuge + importeNormalMayor * cantMayores + importeNormalMenor * cantMenores;
                setImporteTotal(total);
                setPorcentajeDescuento(0.00);
            } else {
                const totalDebito = importeDebito * titularYConyuge + importeDebitoMayor * cantMayores + importeDebitoMenor * cantMenores;
                const totalNormal = importeNormal * titularYConyuge + importeNormalMayor * cantMayores + importeNormalMenor * cantMenores;
                setImporteTotal(totalDebito);
                setPorcentajeDescuento(totalNormal > 0 ? (100 - (totalDebito / totalNormal) * 100) : 0);
            }
        } else {
            // Pago anual (el pago anual se considera como forma de pago deb/cred)
            const totalAnual = importeAnual * titularYConyuge + importeAnualMayor * cantMayores + importeAnualMenor * cantMenores;
            const totalNormal = importeNormal * titularYConyuge + importeNormalMayor * cantMayores + importeNormalMenor * cantMenores;
            setImporteTotal(totalAnual * 12);
            setPorcentajeDescuento(totalNormal > 0 ? (100 - (totalAnual / totalNormal) * 100) : 0);
        }
    }, [idPlan, cantidadIntegrantes, modo, formaPago, titular, conyuge, mayores, cantidadMayores, hijos, cantidadHijos, importeNormalMayor, importeNormalMenor, importeDebitoMayor, importeDebitoMenor, importeAnualMayor, importeAnualMenor]);

    useEffect(() => {

        const fetchItemsPlanes = async () => {
            const items = await CargarItemsPlanesDB();
            setItemsPlanesData(items);
        };
        

        if (pasoActual === 0) {
            fetchItemsPlanes();
        }

        if (pasoActual === 1) {
            setHayError();
            setDatosIntegranteOk(!hayError);
        }
    }, [pasoActual, idActual, documentoActual, nombresActual, apellidoActual, fechaNacimientoActual, sexoActual, emailActual, celularActual, tipoActual, paisActual, provinciaActual, localidadActual, domicilioActual, cuilActual, hayError]);

    useEffect(() => {

        const guardarDatosSociosPendientes = async (): Promise<{sociosInsertados: number, sociosValidados: boolean, correoBienvenidaEnviado: boolean}> => {
            let localCorreoBienvenidaEnviado = false;
            let localSociosInsertados = 0;
            let localSociosValidados = false;

            try {

                console.log("Guardando datos de socios pendientes de pago...");
                console.log("Integrantes ordenados: ", integrantesOrdenados);

                const sociosAInsertar = integrantesOrdenados.length;

                // Insertar los socios en la base de datos
                const resultadoSocios = await InsertarSociosPendientePago(integrantesOrdenados, codigoAgente, idPlan);

                const datosEmailBienvenida = {
                    documento: elTitular.documento,
                    apellido: elTitular.apellido.trim(),
                    nombres: elTitular.nombres.trim(),
                    email: elTitular.email,
                    celular: elTitular.celular,
                    plan: nombrePlan,
                    importe: importeTotal,
                    cantidad: cantidadIntegrantes
                };

                const grupoFamiliarEmail: EmailGrupoFamiliar[] = []

                const recorroArreglo = integrantesOrdenados.map(integrante => {
                    grupoFamiliarEmail.push({
                        documento: integrante.documento,
                        apellido: integrante.apellido.trim(),
                        nombres: integrante.nombres.trim(),
                        email: integrante.email,
                        celular: integrante.celular,
                        fecnac: integrante.fechaNacimiento,
                        tipoIntegrante: integrante.tipo
                    });
                });

                localSociosInsertados = resultadoSocios.socios_insertados;

                if (resultadoSocios.mensaje === "ok")
                {
                    // Verifico si los socios fueron insertados correctamente
                    if (resultadoSocios.socios_insertados === sociosAInsertar) {
                        
                        // Vuelvo a verificar que todos los socios hayan sido insertados correctamente, consultando nuevamente a la base de datos por el titular y sus familiares.

                        const verificacionSociosInsertados = await VerificarSociosInsertados(integrantesOrdenados, codigoAgente, idPlan);
                        
                        if (verificacionSociosInsertados.socios_verificados === "ok") {
                            // Los socios fueron insertados correctamente, puedo avanzar con el envio del correo de bienvenida.
                            localSociosValidados = true;            
                            setSociosInsertados(true);

                            const resultadoEmailBienvenida = await EnviarCorreoBienvenidaCoordinarPago(datosEmailBienvenida, grupoFamiliarEmail);

                            console.log("guardarSociosPendientes - Resultado del envío de correo de bienvenida: ", resultadoEmailBienvenida);

                            if (resultadoEmailBienvenida.email_enviado === "si") {
                                localCorreoBienvenidaEnviado = true;
                            } else {
                                localCorreoBienvenidaEnviado = false;
                            }
                        } else {
                            // No se pudieron verificar que los socios hayan sido insertados correctamente, no puedo avanzar con el envio del correo de bienvenida.
                            localSociosValidados = false;
                            localCorreoBienvenidaEnviado = false;
                            setSociosInsertados(false);
                        }
                    } else {
                        // No se insertaron correctamente los socios, no puedo avanzar con el envio del correo de bienvenida.
                        localSociosValidados = false;
                        localCorreoBienvenidaEnviado = false;
                        setSociosInsertados(false);
                    }
                }
                return {"sociosInsertados": localSociosInsertados, "sociosValidados": localSociosValidados, "correoBienvenidaEnviado": localCorreoBienvenidaEnviado};

            } catch (error) {
                console.error("Error guardando datos de socios:", error);
                return {"sociosInsertados": localSociosInsertados, "sociosValidados": localSociosValidados, "correoBienvenidaEnviado": localCorreoBienvenidaEnviado};
            }
        };

        const ObtenerSuscripcionMP = async (): Promise<Integrante[]> => {
            const tmpPagador = {
                titular: elTitular.documento,
                payerFirstName: elTitular.nombres.trim(),
                payerLastName: elTitular.apellido.trim(),
                payerEmail: elTitular.email,
                identification: {
                    type: "DNI",
                    number: elTitular.documento
                }
            };

            const tmpPago = {
                selectedPaymentMethod: "",
                paymentType: "",
                paymentMethodId: "",
                installments: 1,
                cardToken: "",
                cardIssuerId: "",
                transactionAmount: importeTotal
            };

            try {
 
                if (ReferenciaGenerada.current) return []; // Si ya se generó la referencia, no hago nada.
                
                const estaSuscripcion = await SuscripcionMP (tmpPagador, tmpPago);

                if (estaSuscripcion.subscription_mp.id.trim().length > 0 && estaSuscripcion.subscription_mp.init_point.trim().length > 0 && estaSuscripcion.subscription_mp.back_url.trim().length > 0 && estaSuscripcion.subscription_mp.external_reference.trim().length > 0) {

                    ReferenciaGenerada.current = true;

                    // Guardo la suscripción de Mercado Pago en el estado
                    setLaSuscripcionMP({id: estaSuscripcion.subscription_mp.id, init_point: estaSuscripcion.subscription_mp.init_point, back_url: estaSuscripcion.subscription_mp.back_url, referencia: estaSuscripcion.subscription_mp.external_reference});
                    
                    //complete integrantes array with reference of Mercado Pago
                    const integrantesConReferenciaMP = actualizarReferenciaIntegrantes(estaSuscripcion.subscription_mp.external_reference);

                    setFormularioPagoIsLoading(false);

                    // Vuelvo a ordenar el arreglo de integrantes.
                    integrantesOrdenados = ordenarIntegrantes(integrantesConReferenciaMP);
                    return integrantesConReferenciaMP;
                } else {
                    console.error("Error: La suscripción de Mercado Pago no tiene los datos necesarios.");
                    return [];
                } 
            } catch (error) {
                console.error("Error al obtener la suscripción de Mercado Pago:", error);
                return [];
            }
        };

        if (pasoActual === 2) {
            if (elTitular.id === -1) {
                setElTitular(getTitular());
            }
            if (!enviandoEmail && !emailValidado && !emailEnviado && elTitular.id !== -1) {
                if (validarEmail === 'S') {
                    setEnviandoEmail(true);
                    // Enviar email al titular
                    EnviarCorreoValidacion(elTitular.documento, elTitular.apellido.trim() + ", " + elTitular.nombres.trim(), elTitular.email, elTitular.celular)
                    .then(resultado => {
                        if (resultado.mensaje === 'ok' && resultado.codigo_guardado === "1" && resultado.email_enviado === "si") {
                            //console.log("Email enviado");
                            setEmailEnviado(true);
                            setEnviandoEmail(false);
                            setErrorEmail('');
                        } else {
                            //console.log("Email enviado (con errores)");
                            setEmailEnviado(true);
                            setEnviandoEmail(false);
                            setErrorEmail(resultado.mensaje);
                        }
                    })
                    .catch(error => {
                        //console.log("Email enviado (con errores - catch)");
                        setEmailEnviado(true);
                        setEnviandoEmail(false);
                        setErrorEmail(error);
                    });
                } else {
                    setEmailEnviado(true);
                    setEmailValidado(true);
                    setErrorEmail('');
                }
            }
            if (!enviandoSMS && !celularValidado && !smsEnviado && elTitular.id !== -1) {
                if (validarCelular === 'S') {
                    setEnviandoSMS(true);
                    // Enviar SMS al titular
                    EnviarSMSValidacion(elTitular.documento, elTitular.apellido.trim() + ", " + elTitular.nombres.trim(), elTitular.email, elTitular.celular)
                    .then(resultado => {
                        if (resultado.mensaje === 'ok' && resultado.codigo_guardado === "1" && resultado.sms_enviado === "si") {
                            //console.log("SMS enviado");
                            setSMSEnviado(true);
                            setEnviandoSMS(false);
                            setErrorSMS('');
                        } else {
                            //console.log("SMS enviado (con errores)");
                            setErrorSMS(resultado.mensaje);
                            setEnviandoSMS(false);
                            setSMSEnviado(true);
                        }
                    })
                    .catch(error => {
                        //console.log("SMS enviado (con errores - catch)");
                        setSMSEnviado(true);
                        setEnviandoSMS(false);
                        setErrorSMS(error);
                    });
                } else {
                    setSMSEnviado(true);
                    setCelularValidado(true);
                    setErrorSMS('');
                }
            }
        }

        // Procesando el paso 03 - Pago online por Mercado Pago
        // Obtengo la suscripción de Mercado Pago y guardo los datos de los socios con pago pendiente. Si el plan no tiene pago online, solo guardo los datos de los socios con pago pendiente.
        if (pasoActual === 3) {

            // Estoy en el paso de pago
            if (pagoOnline === 'S' || pagoOnline === 'P') {
                // Obtengo la suscripción de Mercado Pago
                    ObtenerSuscripcionMP().then(nuevosIntegrantes => {
                        
                        if (nuevosIntegrantes.length === 0) {
                            // No se pudo obtener la suscripción de Mercado Pago, no guardo los datos de los socios con pago pendiente.
                            setDatosGuardados('N');
                            return;
                        }
                        
                        integrantesOrdenados = ordenarIntegrantes(nuevosIntegrantes);

                        //Contar los registros de integrantesOrdenados que tengan referencia <> ''
                        const cantidadIntegrantesConReferencia = integrantesOrdenados.filter(integrante => integrante.referencia.trim() !== '').length;
                    
                        if (cantidadIntegrantesConReferencia === integrantesOrdenados.length) {
                            // Todos los integrantes tienen referencia, puedo guardar los datos de los socios con pago pendiente.
                            guardarDatosSociosPendientes().then(resultado => {
                                setResultadoValidarGuardadoSocios(resultado);
                                if (resultado.sociosInsertados === integrantesOrdenados.length && resultado.sociosValidados === true) {
                                    setDatosGuardados('S');
                                } else {
                                    // No todos los integrantes tienen referencia, no guardo los datos de los socios con pago pendiente.
                                    setDatosGuardados('N');
                                }
                            });
                        } else {
                            // No todos los integrantes tienen referencia, no guardo los datos de los socios con pago pendiente.
                            setDatosGuardados('N');
                        }
                    });
            } else {
                // El plan no tiene pago online
                guardarDatosSociosPendientes().then(resultado => {
                    setResultadoValidarGuardadoSocios(resultado);
                    if (resultado.sociosInsertados === integrantesOrdenados.length && resultado.sociosValidados === true) {
                        setDatosGuardados('S');
                    } else {
                        // No todos los integrantes tienen referencia, no guardo los datos de los socios con pago pendiente.
                        setDatosGuardados('N');

                    }
                });
            }
        }
    }, [pasoActual, enviandoEmail, enviandoSMS, emailEnviado, smsEnviado, emailValidado, celularValidado, elTitular]);
    

    return (
        <section id={id} className={`flex flex-col items-center p-2 h-dvh ${navegacionFija ? 'mt-[50px] justify-center' : 'mt-[5px] justify-start'}`}>
            <div className={`flex flex-col items-center justify-center w-full px-3 bg-white border-2 rounded-xl border-vp-azul min-w-[280px] max-w-[600px] pb-4 shadow-md shadow-vp-gris`}>
                <h2 className="text-center font-metropolis mb-4 mt-4 text-3xl xxs:text-xl xs:text-2xl tracking-tight font-regular text-gray-900 ">Cotizador Online</h2>
                <Stepper activeStep={paso} className="w-full flex-wrap">
                    {pasos.map((label, index) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
                {pasoActual === 0 && (
                    <>
                    <div className="flex flex-col justify-center items-start w-full">
                        <h3 className="text-left font-metropolis mb-2 mt-4 text-2xl xxs:text-lg xs:text-xl tracking-tight font-regular text-gray-900 ">Seleccioná el Plan</h3>
                    </div>
                    <div className="flex flex-row justify-start items-center w-full">
                        <div>
                            <FormControl className="flex flex-col justify-center items-center w-full min-w-[150px]" size="small">
                                <InputLabel id="selectPlanLabel">Plan</InputLabel>
                                    <Select
                                        labelId="selectPlanLabel"
                                        id="selectPlan"
                                        value={idPlan.toString()}
                                        label="Plan"
                                        onChange={handleChange}
                                    >
                                        <MenuItem selected value="-1" disabled>
                                            Seleccioná el plan
                                        </MenuItem>
                                        {Object.values(planes).map((plan: any) => {
                                            return <MenuItem key={plan.id} value={plan.id}>{plan.title}</MenuItem>
                                        })}
                                    </Select>
                            </FormControl>
                        </div>
                        {/* <div className="flex flex-col justify-center items-center w-full" >
                            {idPlan !== -1 && (<h3 className="flex justify-end w-full font-metropolis text-2xl xxs:text-lg xs:text-xl tracking-tight font-regular text-gray-900 ">
                                <p className="flex flex-row flex-wrap justify-end items-center font-metropolis font-regular text-lg text-black">Importe Total: <span className="font-bold"><PrecioConFormato precio={importeTotal} decimales={0} /></span><span className={`font-metropolis font-bold text-sm ${modo === 'mes' ? 'text-vp-azul' : 'text-vp-verde'} `}> /{modo}</span></p>
                            </h3>)}
                        </div>) */}
                    </div>

                    <div className="flex flex-col w-full border rounded-b-xl mt-2 mb-2">
                        <Accordion disabled={idPlan === -1}>
                            <AccordionSummary
                            expandIcon={<ArrowDropDownIcon />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                            >
                                <Typography>Detalles del plan<span className="font-bold"> - (Click aquí para ver Detalles)</span></Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className="font-metropolis font-bold text-sm">
                                    {descripcionPlan}
                                </div>
                                <div className="font-metropolis font-regular text-sm my-2">El plan incluye:</div>
                                <div className="rounded-b-xl group-hover:text-black group-hover:bg-stone-100 transition w-full h-full pb-2">
                                    {itemsplanesData.filter(item => item.idplan === idPlan).map(item => (
                                        <div key={item.id} className="flex flex-row flex-nowrap justify-start items-center w-full pl-2">
                                            <CheckCircleOutlineIcon className='text-vp-verde pr-1' />
                                            <p className="font-metropolis font-normal text-sm">{item.title}</p>
                                        </div>
                                    ))}
                                </div>
                            </AccordionDetails>
                        </Accordion>
                    </div>

                    {idPlan !== -1 && (
                    <>
                    <div className="flex flex-col justify-center items-start w-full border-t-2 border-vp-azul mt-2">
                        <h3 className="text-left font-metropolis mb-2 mt-2 text-2xl xxs:text-lg xs:text-xl tracking-tight font-regular text-gray-900 ">Grupo Familiar</h3>
                    </div>
                    <div className="flex flex-col justify-center items-start w-full">
                        
                        {/* Slider de titular */}
                        <div className="flex flex-row items-center px-2 w-full">
                            <FormControlLabel
                                control={
                                    <Switch checked={titular} onChange={handleChangeTitular} name="titular" disabled/>
                                }
                                label="Titular"
                            />
                            <div>
                                <h3 className={`font-metropolis font-regular text-md ${(idPlan !== -1) ? 'text-black': 'text-black-38'} flex xxs:hidden xs:hidden`}>(hasta {maxedadtitular} años)</h3>
                            </div>
                        </div>

                        {/* Slider de conyuge */}

                        {cantidadMaximaConyuge == 1 && (
                            <div className="flex flex-row items-center px-2 w-full">
                            <FormControlLabel
                                control={
                                    <Switch checked={conyuge} onChange={handleChangeConyuge} name="conyuge" disabled={idPlan === -1}/>
                                }
                                label="Conyuge"
                            />
                            <div>
                                <h3 className={`font-metropolis font-regular text-md ${(idPlan !== -1) ? 'text-black': 'text-black-38'} flex xxs:hidden xs:hidden`}>(hasta {maxedadconyuge} años)</h3>
                            </div>
                            <div className="flex flex-col ml-auto">
                                <ContadorItems cantidad={conyuge ? 1 : 0} deshabilitado={(idPlan === -1)} setCantidadItem={setCantidadConyugeLocal} cantidadMaxima={cantidadMaximaConyuge}/>
                            </div>
                        </div>)}

                        {/* Slider de hijos */}
                        {cantidadMaximaMenores > 0 && (
                            <div className="flex flex-row items-center px-2 w-full">
                            <FormControlLabel
                                control={
                                    <Switch checked={hijos} onChange={handleChangeHijos} name="hijos" disabled={idPlan === -1}/>
                                }
                                label="Menores"
                            />
                            <div>
                                <h3 className={`font-metropolis font-regular text-md ${(idPlan !== -1) ? 'text-black': 'text-black-38'} flex xxs:hidden xs:hidden`}>(hasta {maxedadmenor} años)</h3>
                            </div>
                            <div className="flex flex-col ml-auto">
                                <ContadorItems cantidad={cantidadHijos} deshabilitado={(idPlan === -1)} setCantidadItem={setCantidadHijosLocal} cantidadMaxima={cantidadMaximaMenores} />
                            </div>
                        </div>)}

                        {/* Slider de mayores */}
                        {cantidadMaximaMayores > 0 && (
                            <div className="flex flex-row items-center px-2 w-full">
                            <FormControlLabel
                                control={
                                    <Switch checked={mayores} onChange={handleChangeMayores} name="mayores" disabled={idPlan === -1}/>
                                }
                                label="Mayores"
                            />
                            <div>
                                <h3 className={`font-metropolis font-regular text-md ${(idPlan !== -1) ? 'text-black': 'text-black-38'} flex xxs:hidden xs:hidden`}>(hasta {maxedadmayor} años)</h3>
                            </div>
                            <div className="flex flex-col ml-auto">
                                <ContadorItems cantidad={cantidadMayores} deshabilitado={(idPlan === -1)} setCantidadItem={setCantidadMayoresLocal} cantidadMaxima={cantidadMaximaMayores} />
                            </div>
                        </div>)}

                        <div className="flex flex-col justify-center items-center w-full px-2" >
                            {idPlan !== -1 && (<h3 className="flex justify-end w-full font-metropolis text-2xl xxs:text-lg xs:text-xl tracking-tight font-regular text-gray-900 ">
                                <p className="font-metropolis font-regular text-lg text-black"># Integrantes: <span className="font-bold">{cantidadIntegrantes}</span></p>
                            </h3>)}
                        </div>
                    </div>
                    <div className="flex flex-col justify-center items-start w-full border-t-2 border-vp-azul mt-2">
                        <h3 className="text-left font-metropolis mb-2 mt-2 text-2xl xxs:text-lg xs:text-xl tracking-tight font-regular text-gray-900 ">Forma de pago</h3>
                    </div>
                    <div className="flex flex-col justify-center items-start w-full">
                        <div className="px-2">
                            <FormControlLabel
                                control={
                                    <Switch checked={formaPago === 'efectivo' ? false : true} onChange={handleChangeFormaPago} name="formaPago" disabled={idPlan === -1}/>
                                }
                                label="Suscripción mensual (Tarjeta de Crédito / Débito)"
                            />
                        </div>
                        {/*<div className="px-2">
                            <FormControlLabel
                                control={
                                    <Switch checked={modo === 'año' ? true : false} onChange={handleChangeModalidad} name="modoAbono" disabled={idPlan === -1}/>
                                }
                                label="Pago Anual"
                            />
                            </div>*/}
                        <div className="flex flex-col justify-center items-center w-full" >
                            {idPlan !== -1 && (<h3 className="flex justify-end w-full font-metropolis text-2xl xxs:text-lg xs:text-xl tracking-tight font-regular text-gray-900 ">
                                <p className={`font-metropolis font-regular text-lg ${porcentajeDescuento !== 0 ? 'text-black':'text-red-700'}`}>{porcentajeDescuento !== 0 ? 'Descuento Aplicado:' : 'Sin descuentos especiales'} <span className={`font-bold ${(modo === 'año' ? 'text-vp-verde' : 'text-vp-azul')}`}>{porcentajeDescuento !== 0 ? porcentajeDescuento.toFixed(0) + ' %' : ''}</span></p>
                            </h3>)}
                        </div>
                    </div>
                    </>)}

                    <div className="flex flex-col justify-end items-center w-full border-t-2 border-vp-azul mt-2">
                        {idPlan !== -1 && (<h3 className="flex justify-end w-full font-metropolis text-2xl xxs:text-lg xs:text-xl tracking-tight font-regular text-gray-900 ">
                            <p className="flex flex-row flex-wrap mt-3 justify-end items-center font-metropolis font-regular text-xl text-black">Importe Total:<span className="font-bold ml-2"><PrecioConFormato precio={importeTotal} decimales={0} /></span><span className={`font-metropolis font-bold text-sm ${modo === 'mes' ? 'text-vp-azul' : 'text-vp-verde'} `}> /{modo}</span></p>
                        </h3>)}
                    </div>
                    </>
                )}
                {pasoActual === 1 && (
                    <>
                    <div className="flex flex-col justify-center items-start w-full">
                        <div className="flex flex-row justify-between items-center w-full">
                            <div className="flex flex-col justify-start items-center">
                                <h3 className="text-left font-metropolis mb-2 mt-4 text-2xl xxs:text-lg xs:text-xl tracking-tight font-regular text-gray-900 ">Integrantes del Grupo Familiar (<span className="text-vp-azul text-md">{nombrePlan}</span>)</h3>
                            </div>
                        </div>                        
                    </div>                    
                    <div className="flex flex-col justify-center items-start w-full">
                        <div className="flex flex-row border-b-2 border-vp-gris justify-between items-center w-full pb-1">
                            <div className="flex flex-col text-sm items-start w-[15%] xxs:hidden xs:hidden">
                                <h3 className="font-bold text-left">Documento</h3>
                            </div>
                            <div className="flex flex-col text-sm items-start w-[10%]">
                                <h3 className="font-bold text-left">Tipo</h3>
                            </div>
                            <div className="flex flex-col text-sm items-start w-[35%]">
                                <h3 className="font-bold">Apellido y Nombres</h3>
                            </div>
                            <div className="flex flex-col text-sm items-start w-[15%]">
                                <h3 className="font-bold">Fecha Nac.</h3>
                            </div>
                            <div className="flex flex-col text-sm items-start w-[10%] xxs:hidden xs:hidden">
                                <h3 className="font-bold">Sexo</h3>
                            </div>
                            <div className="flex flex-col text-sm items-center w-[15%]">
                                <h3 className="font-bold">Acción</h3>
                            </div>
                        </div>
                        {cantidadIntegrantesCargados === 0 && (
                            <div className="flex flex-row justify-center items-center w-full mt-2 mb-2">
                                <p className="font-metropolis font-regular text-sm text-black">No hay integrantes cargados</p>
                            </div>
                        )}
                        {cantidadIntegrantesCargados !== 0 && (
                            <>
                            {integrantesOrdenados.map((integrante, index) => {
                                return (
                                    <div key={integrante.id} className="flex flex-row border-b-2 border-vp-gris pt-1 pb-1 justify-between items-center w-full">
                                        <div className="flex flex-col text-sm items-start w-[15%] xxs:hidden xs:hidden">
                                            <h3>{integrante.documento}</h3>
                                        </div>
                                        <div className="flex flex-col text-sm items-start w-[10%]">
                                            <h3>{integrante.tipo}</h3>
                                        </div>
                                        <div className="flex flex-col text-sm items-start w-[35%]">
                                            <h3>{integrante.apellido}, {integrante.nombres}</h3>
                                        </div>
                                        <div className="flex flex-col text-sm items-start w-[15%]">
                                            <h3>{integrante.fechaNacimiento}</h3>
                                        </div>
                                        <div className="flex flex-col text-sm items-start w-[10%] xxs:hidden xs:hidden">
                                            <h3>{integrante.sexo}</h3>
                                        </div>
                                        <div className="flex flex-row justify-center items-center gap-2 flex-nowrap xxs:flex-wrap xs:flex-wrap w-[15%]">
                                            <button id={`btnEditar${integrante.id}`} className="vp-btn-naranja-accion" onClick={editarIntegrante(integrante.id)} disabled={editando || eliminando }><EditIcon fontSize="small"/></button>
                                            <button className="vp-btn-rojo-accion" onClick={eliminarIntegranteLocal(integrante.id)} disabled={editando || eliminando || (integrante.tipo === 'Titular' && (emailValidado || celularValidado))}><DeleteIcon fontSize="small"/></button>
                                        </div>
                                    </div>
                                );
                            })}
                            </>
                        )}
                        {((cantidadIntegrantesCargados < cantidadIntegrantes) || (editando) || (eliminando)) && (
                            <>
                            <h3 className="font-metropolis font-bold text-md mt-2">Formulario de carga de integrantes</h3>
                            <h3 className="font-metropolis font-regular text-sm mb-3">Todos los campos son obligatorios</h3>
                            {/* Fila 1: Nro. DNI, tipo de integrante y apellido */}
                            <div className="flex flex-row w-full flex-wrap gap-2">
                                <div className="flex flex-col">
                                    <label className="text-sm">Nro. DNI</label>
                                    <TextField id="documento" value={documentoActual}
                                        sx={{
                                            '& .MuiInputBase-input': {
                                                padding: '6px', // Ajusta el padding interno del input
                                            },
                                        }}
                                        className={`w-[110px]`}
                                        error={documentoActualError}
                                        onChange={(e) => setDocumentoActual(e.target.value)}
                                        autoFocus={true}
                                        disabled={eliminando}
                                    />
                                </div>
                                <div className="flex flex-col">
                                    <label className="text-sm">Tipo de Integrante</label>
                                    <Select id="tipointegrante" value={tipoActual} onChange={(e) => setTipoActual(e.target.value as '' | 'Titular' | 'Conyuge' | 'Menor' | 'Mayor')}
                                        sx={{
                                            '& .MuiInputBase-input': {
                                                padding: '6px', // Ajusta el padding interno del input
                                            },
                                        }}
                                        className="w-[120px]"
                                        error={tipoActual === ''}
                                        disabled={eliminando || editando}
                                    >
                                        {(titular && (!titularCargado || editando || eliminando)) && (<MenuItem value="Titular">Titular</MenuItem>)}
                                        {(conyuge && (!conyugeCargado || editando || eliminando)) && (<MenuItem value="Conyuge">Conyuge</MenuItem>)}
                                        {((cantidadHijos > 0 && cantidadHijosCargados < cantidadHijos) || (editando || eliminando)) && (<MenuItem value="Menor">Menor</MenuItem>)}
                                        {((cantidadMayores > 0 && cantidadMayoresCargados < cantidadMayores) || (editando || eliminando)) && (<MenuItem value="Mayor">Mayor</MenuItem>)}
                                    </Select>
                                </div>
                                <div className="flex flex-col flex-grow">
                                    <label className="text-sm">Apellido</label>
                                    <TextField id="apellido" value={apellidoActual}
                                        sx={{
                                            '& .MuiInputBase-input': {
                                                padding: '6px', // Ajusta el padding interno del input
                                            },
                                        }}
                                        className="w-full"
                                        onChange={(e) => setApellidoActual(e.target.value)}
                                        autoFocus={false}
                                        error={apellidoActualError}
                                        disabled={eliminando}
                                    />
                                </div>
                            </div>
                            {/* Fila 2: Nombres, Fecha de Nac. y Sexo */}
                            <div className="flex flex-row w-full flex-wrap gap-2 mt-2">
                                <div className="flex flex-col flex-grow">
                                    <label className="text-sm">Nombres</label>
                                    <TextField id="nombres" value={nombresActual}
                                        sx={{
                                            '& .MuiInputBase-input': {
                                                padding: '6px', // Ajusta el padding interno del input
                                            },
                                        }}
                                        className="w-full"
                                        onChange={(e) => setNombresActual(e.target.value)}
                                        autoFocus={false}
                                        error={nombresActualError}
                                        disabled={eliminando}
                                    />
                                </div>
                                <div className="flex flex-col">
                                    <label className="text-sm">Fecha Nacimiento</label>
                                {/* <TextField id="fechanacimiento" value={fechaNacimientoActual}
                                        sx={{
                                            '& .MuiInputBase-input': {
                                                padding: '6px', // Ajusta el padding interno del input
                                            },
                                        }}
                                        type="date"
                                        className="w-[130px]"
                                        onChange={(e) => setFechaNacimientoActual(e.target.value)}
                                        autoFocus={false}
                                        error={fechaNacimientoActualError}
                                        disabled={eliminando}
                                    />*/}
                                    <div>
                                        <DatePicker etiqueta="" initialDate={fechaNacimientoActual} onDateChange={handleFechaNacimientoChange}
                                            ContainerSX={{
                                                width: undefined,
                                                padding: '4px',
                                                borderRadius: '5px',
                                                marginBottom: '8px',
                                            }}
                                            LabelSX={{
                                                fontSize: '12px',
                                            }}
                                        />
                                    </div>
                                </div> 

                                <div className="flex flex-col">
                                    <label className="text-sm">Sexo</label>
                                    <Select id="sexo" value={sexoActual} onChange={(e) => setSexoActual(e.target.value as 'Masc.' | 'Fem.' )}
                                        sx={{
                                            '& .MuiInputBase-input': {
                                                padding: '6px', // Ajusta el padding interno del input
                                            },
                                        }}
                                        className="w-[120px]"
                                        error={sexoActual.trim().length === 0}
                                        disabled={eliminando}
                                    >
                                        <MenuItem value="Masc.">Masc.</MenuItem>
                                        <MenuItem value="Fem.">Fem.</MenuItem>
                                    </Select>
                                </div>
                            </div>
                            {/* Fila 3: Email, Celular (solo para el titular) */}
                            {tipoActual === 'Titular' && (<div className="flex flex-row w-full flex-wrap gap-2 mt-2">
                                {/* Solo pido email si solicitarEmail es 'S' */}
                                {solicitarEmail === 'S' &&
                                (<div className="flex flex-col flex-grow">
                                    <label className="text-sm">Email</label>
                                    <TextField id="email" value={emailActual}
                                        sx={{
                                            '& .MuiInputBase-input': {
                                                padding: '6px', // Ajusta el padding interno del input
                                            },
                                        }}
                                        type="email"
                                        className="w-full"
                                        onChange={(e) => setEmailActual(e.target.value)}
                                        autoFocus={false}
                                        error={emailActualError}
                                        disabled={eliminando || emailValidado}
                                    />
                                </div>)}
                                {/* Solo pido celular si solicitarCelular es 'S' */}
                                {solicitarCelular === 'S' &&
                                (<div className="flex flex-col flex-grow">
                                    <label className="text-sm">Nro. de Celular (sin 0 ni 15)</label>
                                    <TextField id="celular" value={celularActual}
                                        sx={{
                                            '& .MuiInputBase-input': {
                                                padding: '6px', // Ajusta el padding interno del input
                                            },
                                        }}
                                        className="w-full"
                                        onChange={(e) => setCelularActual(e.target.value)}
                                        autoFocus={false}
                                        error={celularActualError}
                                        disabled={eliminando || celularValidado}
                                    />
                                </div>)}
                                <div className="flex flex-col flex-grow w-full">
                                    <div className="flex flex-col justify-between items-center flex-grow w-full mb-2">
                                        <SeleccionarPais paisInicial={paisActual} onChange={handlePaisChange} onClear={handlePaisClear} eliminando={eliminando}/>
                                    </div>
                                    <div className="flex flex-col justify-between items-center flex-grow w-full mb-2">
                                        <SeleccionarProvincia paisInicial={paisActual} provinciaInicial={provinciaActual} onChange={handleProvinciaChange} onClear={handleProvinciaClear} eliminando={eliminando}/>
                                    </div>
                                    <div className="flex flex-col justify-between items-center flex-grow w-full mb-2">
                                        <SeleccionarLocalidad paisInicial={paisActual} provinciaInicial={provinciaActual} localidadInicial={localidadActual} onChange={handleLocalidadChange} onClear={handleLocalidadClear} eliminando={eliminando}/>
                                    </div>
                                    <div className="flex flex-col justify-between items-start flex-grow w-full mb-2">
                                        <label className="text-sm">Domicilio</label>
                                        <TextField id="domicilio" value={domicilioActual}
                                            sx={{
                                                '& .MuiInputBase-input': {
                                                    padding: '6px', // Ajusta el padding interno del input
                                                },
                                            }}
                                            className="w-full"
                                            onChange={(e) => setDomicilioActual(e.target.value)}
                                            autoFocus={false}
                                            error={domicilioActualError}
                                            disabled={eliminando}
                                        />
                                    </div>
                                    <div className="flex flex-col">
                                        <label className="text-sm">Nro. Cuil</label>
                                        <TextField id="cuil" value={cuilActual}
                                            sx={{
                                                '& .MuiInputBase-input': {
                                                    padding: '6px', // Ajusta el padding interno del input
                                                },
                                            }}
                                            className={`w-[130px]`}
                                            error={cuilActualError}
                                            onChange={(e) => setCuilActual(e.target.value)}
                                            autoFocus={false}
                                            disabled={eliminando}
                                        />
                                    </div>
                                    
                                </div>
                            </div>)}
                            {/* Panel donde se muestran los errores */}
                            {(hayError || socioExiste) && (<div className="flex flex-col justify-start items-start w-full mt-4">
                                        <h3 className="font-metropolis font-bold text-sm text-red-800 mb-2">Hay errores en el formulario.</h3>
                                        <ul className="px-4">
                                            {documentoActualError && (<li className="font-metropolis font-regular text-red-800 text-sm list-disc">Error en el número de documento (se esperan entre 5 y 8 dígitos).</li>)}
                                            {socioExiste && (<li className="font-metropolis font-regular text-red-800 text-sm list-disc">El DNI ingresado ya existe en la base de datos o en la lista de socios actual.</li>)}
                                            {nombresActualError && (<li className="font-metropolis font-regular text-red-800 text-sm list-disc">Se esperan al menos 3 letras en el nombre del integrante.</li>)}
                                            {apellidoActualError && (<li className="font-metropolis font-regular text-red-800 text-sm list-disc">Se esperan al menos 3 letras en el apellido del integrante.</li>)}
                                            {fechaNacimientoActualError && (<li className="font-metropolis font-regular text-red-800 text-sm list-disc">Error en la fecha de nacimiento (edades máximas en años: titular: {maxedadtitular}, conyuge: {maxedadconyuge}, mayores: {maxedadmayor} - menores: {maxedadmenor}).</li>)}
                                            {emailActualError && solicitarEmail === 'S' && (<li className="font-metropolis font-regular text-red-800 text-sm list-disc">Error en la dirección de email. Verificá el email ingresado.</li>)}
                                            {celularActualError && solicitarCelular === 'S' &&(<li className="font-metropolis font-regular text-red-800 text-sm list-disc">Nro. de celular incorrecto. Se esperan 10 dígitos (cód. área + nro).</li>)}
                                            {domicilioActualError && (<li className="font-metropolis font-regular text-red-800 text-sm list-disc">Completar el domicilio con datos válidos.</li>)}
                                            {cuilActualError && (<li className="font-metropolis font-regular text-red-800 text-sm list-disc">Error en el CUIL. Se esperan 11 dígitos numéricos.</li>)}
                                        </ul>
                            </div>)}
                            <div className="flex flex-row flex-grow flex-wrap justify-center items-center mt-6 gap-2 w-50">
                                {!editando ?
                                (
                                    !eliminando ?
                                    (
                                        <>
                                            <button className="flex-grow vp-btn-rojo-sm" onClick={handleBtnReiniciar}><RestartAltIcon className="text-white mr-1 mb-1" />Reiniciar Campos</button>
                                            <button className="flex-grow vp-btn-verde-sm" onClick={handleBtnAgregarIntegrante} disabled={!datosIntegranteOk}><CheckCircleOutlineIcon className="text-white mr-1" /> Confirmar Integrante</button>
                                        </>
                                    )
                                    :
                                    (
                                        <>
                                            <button className="flex-grow vp-btn-azul-sm" onClick={handleBtnReiniciar}><UndoIcon className="text-white mr-1 mb-1" />Cancelar Borrado</button>
                                            <button className="flex-grow vp-btn-rojo-sm" onClick={handleBtnAgregarIntegrante} disabled={!datosIntegranteOk}><CheckCircleOutlineIcon className="text-white mr-1" /> Confirmar Borrado</button>
                                        </>
                                    )
                                )
                                :
                                (
                                    <>
                                       <button className="flex-grow vp-btn-rojo-sm" onClick={handleBtnReiniciar}><UndoIcon className="text-white mr-1 mb-1" />Descartar Cambios</button>
                                       <button className="flex-grow vp-btn-azul-sm" onClick={handleBtnAgregarIntegrante} disabled={!datosIntegranteOk}><SaveOutlinedIcon className="text-white mr-1" /> Guardar Cambios</button>
                                    </>
                                )}
                            </div>
                            </>
                        )}
                        <div className="flex flex-col justify-start items-center mt-4 flex-grow w-full">
                            <div className="flex flex-row justify-start items-center flex-nowrap xxs:flex-wrap xs:flex-wrap flex-grow w-full mt-2 xxs:space-y-2">
                                <div className="flex flex-col justify-start items-center flex-grow">
                                    <h3 className="flex justify-start items-center w-full font-metropolis tracking-tight font-regular text-gray-900 ">
                                        <p className="flex flex-row flex-wrap mt-3 justify-end items-center font-metropolis font-regular text-md text-black">Importe Total:<span className="font-bold ml-2"><PrecioConFormato precio={importeTotal} decimales={0} /></span><span className={`font-metropolis font-bold text-sm ${modo === 'mes' ? 'text-vp-azul' : 'text-vp-verde'} `}> /{modo}</span></p>
                                    </h3>
                                </div>
                                {(cantidadIntegrantesCargados < cantidadIntegrantes) && (<div className="flex flex-col justify-start items-center">
                                    <h3 className="font-metropolis tracking-tight font-regular text-md">Integrantes por cargar: <span className="font-bold">{cantidadIntegrantes - cantidadIntegrantesCargados}</span></h3>
                                </div>)}
                            </div>
                        </div>
                    </div>
                    </>
                )}
                {pasoActual === 2 && (
                    <>
                    {(validarCelular === 'S' || validarEmail === 'S') && 
                    (<div className="flex flex-col justify-center items-start w-full">
                        <h3 className="text-left font-metropolis mb-4 mt-4 text-2xl xxs:text-lg xs:text-xl tracking-tight font-regular text-gray-900 ">Validar datos de contacto</h3>
                    </div>)}
                    {(enviandoEmail || enviandoSMS) ?
                    (
                        <div className="flex flex-col justify-center items-start w-full gap-2">
                            {validarEmail === 'S' && (<div className="flex flex-row justify-start items-start">
                                {!emailEnviado ? (<RadioButtonUncheckedIcon className="mr-1" />) : (<CheckCircleOutlineIcon className="mr-1 text-vp-verde" />)}
                                <h3 className="font-metropolis font-regular text-lg">Enviando código de validación al email del titular...</h3>
                            </div>)}
                            {validarCelular === 'S' && (<div className="flex flex-row justify-start items-start">
                                {!smsEnviado ? (<RadioButtonUncheckedIcon className="mr-1" />) : (<CheckCircleOutlineIcon className="mr-1 text-vp-verde" />)}
                                <h3 className="font-metropolis font-regular text-lg">Enviando código de validación al celular del titular...</h3>
                            </div>)}
                            {(validarEmail === 'S' || validarCelular === 'S') && (<div className="flex flex-col justify-center items-center w-full mt-2">
                                <CircularProgress size={32}/>
                            </div>)}
                        </div>    
                    ) : (
                        <div className="flex flex-col justify-center items-start w-full gap-2">
                            {errorEmail && (
                                <div className="flex flex-row justify-start items-center">
                                    <ErrorOutlineIcon fontSize="small" className="text-red-700" />
                                    <h3 className="text-sm text-red-700">{errorEmail}</h3>
                                </div>                         
                            )}
                            {errorSMS && (
                                <div className="flex flex-row justify-start items-center">
                                    <ErrorOutlineIcon fontSize="small" className="text-red-700" />
                                    <h3 className="text-sm text-red-700">{errorSMS}</h3>
                                </div>                         
                            )}
                            {!emailValidado ? (
                                <div className="flex flex-col">
                                    <h3 className="text-justify text-sm mr-1">Te enviamos un código de validación de 6 dígitos a tu <b>email</b>. Copialo y pegalo (o escribilo) a continuación:</h3>
                                    <div className="flex flex-col w-full flex-grow justify-center items-center">
                                        <TextField id="codigoEmail" value={codigoEmail}
                                            sx={{
                                                '& .MuiInputBase-input': {
                                                    padding: '6px', // Ajusta el padding interno del input
                                                    textAlign: 'center',
                                                },
                                            }}
                                            className={`w-[80px]`}
                                            onChange={(e) => validarCodigoEmail(e.target.value)}
                                            autoFocus={true}
                                        />
                                    </div>
                                    {errorValidarEmail && (
                                    <div className="flex flex-row justify-center items-center mt-1">
                                        <ErrorOutlineIcon fontSize="small" className="text-red-700 mr-1" />
                                        <h3 className="text-sm text-red-700">{errorValidarEmail}</h3>
                                    </div>)}
                                </div>) : (
                                <div className="flex flex-col justify-center items-center w-full">
                                    {validarEmail === 'S' && (<div className="flex flex-row justify-center items-center">
                                        <CheckCircleOutlineIcon fontSize="small" className="text-vp-verde" />
                                        <h3 className="font-metropolis font-bold text-sm text-vp-verde mt-1">Email validado correctamente</h3>
                                    </div>)}
                                </div>
                            )}
                            {!celularValidado ? (
                                <div className="flex flex-col mt-2">
                                    <h3 className="text-justify text-sm mr-1">Te enviamos un código de validación de 6 dígitos a tu <b>celular</b>. Copialo y pegalo (o escribilo) a continuación:</h3>
                                    <div className="flex flex-col w-full flex-grow justify-center items-center">
                                        <TextField id="codigoCelular" value={codigoSMS}
                                            sx={{
                                                '& .MuiInputBase-input': {
                                                    padding: '6px', // Ajusta el padding interno del input
                                                    textAlign: 'center',
                                                },
                                            }}
                                            className={`w-[80px]`}
                                            onChange={(e) => validarCodigoSMS(e.target.value)}
                                        />
                                    </div>
                                    {errorValidarSMS.trim().length > 0 && (
                                    <div className="flex flex-row justify-center items-center mt-1">
                                        <ErrorOutlineIcon fontSize="small" className="text-red-700 mr-1" />
                                        <h3 className="text-sm text-red-700">{errorValidarSMS}</h3>
                                    </div>)}
                                </div>) : (
                                <div className="flex flex-col justify-center items-center w-full">
                                    {validarCelular === 'S' && (<div className="flex flex-row justify-start items-center">
                                        <div className="flex flex-col justift-center items-center">
                                            <CheckCircleOutlineIcon fontSize="small" className="text-vp-verde" />
                                        </div>
                                        <div className="flex flex-col justify-center items-center">
                                            <h3 className="font-metropolis font-bold text-sm text-vp-verde mt-1">Celular validado correctamente</h3>
                                        </div>
                                    </div>)}
                                </div>
                            )}
                        </div>
                    )}
                    {emailValidado && celularValidado &&
                        (<div className="flex flex-col justify-center items-start w-full">
                            <h3 className="text-left font-metropolis mb-1 mt-4 text-2xl xxs:text-lg xs:text-xl tracking-tight font-regular text-gray-900 ">¿Te ayudó un agente comercial?</h3>
                            <h3 className="text-left font-metropolis ml-2 mb-2 mt-2 text-sm tracking-tight font-regular text-gray-900 ">Si te ayudó un agente comercial, ingresá su código:</h3>
                            <div className="flex flex-col items-center justify-center flex-grow w-full">
                                <TextField id="codigoAgente" value={codigoAgente}
                                    sx={{
                                        '& .MuiInputBase-input': {
                                            padding: '6px', // Ajusta el padding interno del input
                                            textAlign: 'center',
                                        },
                                    }}
                                    inputProps={{maxLength: 8}}
                                    placeholder="Código"
                                    className="w-[90px]"
                                    error={codigoAgenteError}
                                    onChange={(e) => validarCodigoAgente(e.target.value)}
                                    autoFocus={false}
                                />
                                {nombreAgenteComercial.trim().length > 0 && (<p className="text-sm text-gray-500 mt-1">{nombreAgenteComercial}</p>)}
                            </div>
                            {codigoAgenteError &&
                            (
                            <div className="flex flex-col justify-center items-center mt-1 flex-grow w-full">
                                <div className="flex flex-row justify-center items-center mt-1">
                                    <ErrorOutlineIcon fontSize="small" className="text-red-700 mr-1" />
                                    <h3 className="text-sm text-red-700">{mensajeErrorCA}</h3>
                                </div>
                                <button className="vp-btn-rojo-sm mt-2" onClick={reiniciarCodigoAgente}>Omitir</button>
                            </div>)}
                            <div className="flex flex-col justify-start items-center mt-4 flex-grow w-full">
                                <div className="flex flex-row justify-start items-center space-x-2">
                                    <Checkbox checked={aceptaTerminos} onChange={handleChangeTerminos} color="primary"/>
                                    <h3 className="font-metropolis font-regular text-md text-black">Acepto los <a href="#" onClick={handleClickVerTerminos} className="text-vp-azul">términos y condiciones</a> de VidaPlus</h3>
                                </div>
                            </div>
                            <div className="flex flex-col justify-start items-center mt-4 flex-grow w-full">
                                <div className="flex flex-row justify-start items-center flex-nowrap xxs:flex-wrap xs:flex-wrap flex-grow w-full mt-2 xxs:space-y-2">
                                    <div className="flex flex-col justify-start items-center flex-grow">
                                        <h3 className="flex justify-start items-center w-full font-metropolis tracking-tight font-regular text-gray-900 ">
                                            <p className="flex flex-row flex-wrap mt-3 justify-end items-center font-metropolis font-regular text-md text-black">Importe Total:<span className="font-bold ml-2"><PrecioConFormato precio={importeTotal} decimales={0} /></span><span className={`font-metropolis font-bold text-sm ${modo === 'mes' ? 'text-vp-azul' : 'text-vp-verde'} `}> /{modo}</span></p>
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </div>)}
                    </>
                )}
                {/* Inicio Formulario de pago */}
                {pasoActual === 3 && (
                    <>
                    {pagoRealizado ? (
                        <div className="container flex flex-col justify-center items-center">
                            <img src={logotexto} className="mt-6 mb-4 h-[40px] " alt="VidaPlus Logo" />
                            <CheckCircleOutline fontSize="large" className="text-vp-verde" />
                            <h3 className="text-2xl font-bold mt-4">¡Suscripción exitosa!</h3>
                            <p className="text-center mt-4">¡Gracias por confiar en nosotros!</p>
                            {sociosInsertados ? (
                                <p className="text-center mt-4">Ya podés disfrutar de nuestros servicios!</p>
                            ) : (
                                <p className="text-center mt-4">Estamos procesando tus datos para que puedas usar pronto nuestros servicios</p>
                            )}
                            {formaPago !== 'efectivo' && (<p className="text-center mt-4">En breve recibirás un correo con los detalles de tu suscripción.</p>)}
                        </div>
                    ):((pagoOnline === 'S' || pagoOnline === 'P') ? (
                        <div className="pt-2 flex flex-col justify-center items-center w-full">
                            <div className="pt-4 flex flex-col justify-center items-center flex-grow w-full space-y-6">
                                {(!resultadoValidarGuardadoSocios?.sociosValidados) ? (
                                    <div className="flex flex-col justify-center items-center w-full">
                                        <CircularProgress size={32} className="mb-4"/>
                                        <h3>Estamos guardando tus datos...</h3>
                                        <br />
                                        <h3 className="text-red-600">Si esta ventana no cambia luego de unos segundos, hubo un error al guardar los datos y debes reintentar la operación nuevamente.</h3>
                                    </div>
                                ) : (
                                    <>
                                    <button
                                        className="vp-btn-verde shadow-md shadow-vp-gris mr-2 flex-grow w-[90%] sm:w-[350px]"
                                        onClick={handleRealizarPago}
                                        disabled={!laSuscripcionMP?.init_point}
                                    >
                                        Pagar ONLINE <br className="sm:hidden" />con MercadoPago
                                    </button>
                                    <button
                                        className="vp-btn-azul shadow-md shadow-vp-gris mr-2 flex-grow w-[90%] sm:w-[350px]"
                                        onClick={handleEsperarContactoComercial}
                                        disabled={!laSuscripcionMP?.init_point}
                                    >
                                        Coordinar PAGO <br className="sm:hidden" />con agente comercial (*)
                                    </button>
                                    <h3>(*) Un <b>agente comercial</b> se pondrá en contacto con vos para coordinar el pago.</h3>
                                </>)}
                            </div>
                            {pagoError && (
                                <div className="flex flex-col justify-center items-center w-full mt-4">
                                    <h3 className="font-metropolis font-bold text-md text-red-800 mb-2">Hubo un error en el proceso de pago.</h3>
                                    <h4 className="font-metropolis font-bold text-md text-red-800 mb-2">{pagoErrorMessage}</h4>
                                    <h4>Volvé al paso anterior y reintentá el pago (Botón Anterior)</h4>
                                </div>
                            )}
                            <div className="flex flex-col justify-start items-center mt-4 flex-grow w-full">
                                <div className="flex flex-row justify-start items-center flex-grow w-full">
                                    <div className="flex flex-col justify-start items-center flex-grow">
                                        <h3 className="flex justify-start items-center w-full font-metropolis tracking-tight font-regular text-gray-900 ">
                                            <p className="flex flex-row flex-wrap mt-1 justify-end items-center font-metropolis font-regular text-md text-black">Importe Total:<span className="font-bold ml-2"><PrecioConFormato precio={importeTotal} decimales={0} /></span><span className={`font-metropolis font-bold text-sm ${modo === 'mes' ? 'text-vp-azul' : 'text-vp-verde'} `}> /{modo}</span></p>
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </div>) : (
                            /* No se realiza pago online - Finaliza el alta para mandar correo a la administración*/
                            <>
                                <div className="container flex flex-col justify-center items-center">
                                    <img src={logotexto} className="mt-6 mb-4 h-[40px] " alt="VidaPlus Logo" />
                                    <CheckCircleOutline fontSize="large" className="text-vp-verde" />
                                    <h3 className="text-2xl font-bold mt-4">¡Suscripción Online exitosa! - Pago OFFLINE</h3>
                                    <p className="text-center mt-4">¡Gracias por confiar en nosotros!</p>
                                    <p className="text-center mt-4">En breve un <b>agente comercial</b> se pondrá en contacto con vos para coordinar el pago de tu suscripción.</p>                                </div>
                            </>))}
                    </>
                )}
                {/* Fin Formulario de pago - Seleccionado PAGO OFFLINE */}
                {pasoActual === 4 && (
                    <>
                        <div className="pt-6 flex flex-col justify-center items-center flex-grow w-full bg-white">
                            <img src={logotexto} className="mb-4 h-[100px] " alt="VidaPlus Logo" />
                            <CheckCircleOutline fontSize="large" className="text-vp-verde" />
                            <h3 className="text-2xl font-bold mt-4">¡Suscripción exitosa! - Pago OFFLINE</h3>
                            <p className="text-center mt-4">¡Gracias por confiar en nosotros!</p>
                            {resultadoValidarGuardadoSocios?.sociosValidados ? (
                                <p className="text-center mt-4 text-vp-verde">* Datos de los socios registrados correctamente.</p>
                            ) : (
                                <p className="text-center mt-4 text-color-rojo">* Hubo un problema al guardar los datos de los socios.</p>
                            )}
                            {resultadoValidarGuardadoSocios?.correoBienvenidaEnviado ? (
                                <p className="text-center mt-4 text-vp-verde">* Correo de bienvenida enviado correctamente.</p>
                            ) : (
                                <p className="text-center mt-4 text-color-rojo">* Hubo un problema al enviar el correo de bienvenida.</p>
                            )}
                            <br />
                            <p className="text-center mt-4">En breve un <b>agente comercial</b> se pondrá en contacto con vos para coordinar el pago de tu suscripción.</p>
                        </div>
                    </>
                )}
                {pagoRealizado || (pagoOnline === 'N' && datosGuardados === 'S') ? (
                    <div className="flex flex-row justify-center items-center flex-grow w-full space-x-2 border-t-2 border-vp-azul mt-4">
                        <button onClick={handleHome} className="mt-2 vp-btn-azul xxs:w-full xs:w-full"><HomeIcon className="mr-2"/>volver al Inicio</button>
                    </div>
                ):(
                    <div className="flex flex-row flex-nowrap xxs:flex-wrap xs:flex-wrap w-full mt-4 justify-between items-center gap-2 xxs:space-y-2 xs:space-y-2 border-t-2 border-vp-azul pt-3">
                        <div className="flex flex-col justify-center items-center flex-nogrow xxs:flex-grow xs:flex-grow">
                            <button onClick={reiniciarFormulario} className="vp-btn-rojo justify-center items-center xxs:w-full xs:w-full"><RestartAltIcon className="mr-2"/>Reiniciar Formulario</button>
                        </div>
                        <div className="flex flex-row justify-end items-center flex-grow w-full space-x-2">
                            {(pasoActual > 0 && pasoActual < 4) && (<button onClick={handleBack} className="vp-btn-azul xxs:w-full xs:w-full">Anterior</button>)}
                            {/*pasoActual < 4 && (<button onClick={handleNext} className="vp-btn-azul ml-auto" disabled={(idPlan === -1) || (pasoActual === 1 && cantidadIntegrantesCargados !== cantidadIntegrantes)}>{pasoActual === 0 ? 'Contratar Online!' : 'Siguiente'}</button>)*/}
                            {pasoActual < 4 && (<button onClick={handleNext} className="vp-btn-azul xxs:w-full xs:w-full" disabled={(idPlan === -1) || (pasoActual === 1 && cantidadIntegrantesCargados !== cantidadIntegrantes) || (pasoActual === 2 && (!emailValidado || !celularValidado || codigoAgenteError || !aceptaTerminos) || (pasoActual === 3 && !pagoRealizado))}>{pasoActual === 0 ? 'Contratar Online!' : 'Siguiente'}</button>)}
                            {pasoActual === 4 && (<button onClick={handleHome} className="mt-2 vp-btn-azul xxs:w-full xs:w-full"><HomeIcon className="mr-2"/>volver al Inicio</button>)}
                        </div>
                    </div>
                )}

            </div>
            {verTerminos && (
            <Dialog open={verTerminos} onClose={handleCerrarTerminos} fullWidth={true} maxWidth="md"
                scroll={scroll}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <DialogTitle id="scroll-dialog-title">Términos y Condiciones - VidaPlus</DialogTitle>
                    <DialogContent dividers={scroll === 'paper'}>
                        <DialogContentText
                            id="scroll-dialog-description"
                            tabIndex={-1}
                        >
                            <h1 className="text-sm font-bold">{TerminosYCondiciones["01_introduccion"].titulo}</h1>
                            <p className="text-sm text-justify mb-3">{TerminosYCondiciones["01_introduccion"].descripcion}</p>
                            <h1 className="text-sm font-bold">{TerminosYCondiciones["02_descripcion_servicio"].titulo}</h1>
                            <p className="text-sm text-justify mb-3">{TerminosYCondiciones["02_descripcion_servicio"].descripcion}</p>
                            <h1 className="text-sm font-bold">{TerminosYCondiciones["03_importante"].titulo}</h1>
                            <p className="text-sm text-justify mb-3">{TerminosYCondiciones["03_importante"].descripcion}</p>
                            <h1 className="text-sm font-bold">{TerminosYCondiciones["04_alcance_limitaciones"].titulo}</h1>
                            <p className="text-sm text-justify mb-3">{TerminosYCondiciones["04_alcance_limitaciones"].descripcion}</p>
                            <h1 className="text-sm font-bold">{TerminosYCondiciones["05_usuarios"].titulo}</h1>
                            <p className="text-sm text-justify mb-3">{TerminosYCondiciones["05_usuarios"].descripcion}</p>
                            <h1 className="text-sm font-bold">{TerminosYCondiciones["06_derechos_obligaciones"].titulo}</h1>
                            <p className="text-sm text-justify mb-3">{TerminosYCondiciones["06_derechos_obligaciones"].descripcion}</p>
                            <h1 className="text-sm font-bold">{TerminosYCondiciones["07_modificaciones"].titulo}</h1>
                            <p className="text-sm text-justify mb-3">{TerminosYCondiciones["07_modificaciones"].descripcion}</p>
                            <h1 className="text-sm font-bold">{TerminosYCondiciones["08_reembolsos_reclamaciones"].titulo}</h1>
                            <p className="text-sm text-justify mb-3">{TerminosYCondiciones["08_reembolsos_reclamaciones"].descripcion}</p>
                            <h1 className="text-sm font-bold">{TerminosYCondiciones["09_proteccion_datos"].titulo}</h1>
                            <p className="text-sm text-justify mb-3">{TerminosYCondiciones["09_proteccion_datos"].descripcion}</p>
                            <h1 className="text-sm font-bold">{TerminosYCondiciones["10_limitacion_responsabilidad"].titulo}</h1>
                            <p className="text-sm text-justify mb-3">{TerminosYCondiciones["10_limitacion_responsabilidad"].descripcion}</p>
                            <h1 className="text-sm font-bold">{TerminosYCondiciones["11_planes_beneficios"].titulo}</h1>
                            <p className="text-sm text-justify mb-1">{TerminosYCondiciones["11_planes_beneficios"].descripcion}</p>
                            <ol className="list-decimal list-outside pl-6 mb-3">
                            {TerminosYCondiciones["11_planes_beneficios"].servicios.map((servicio, index) => {
                                return (
                                    <li key={index} className="text-sm">{servicio}</li>
                                );
                            })}
                            </ol>
                            <h1 className="text-sm font-bold">{TerminosYCondiciones["12_planes_disponibles"].titulo}</h1>
                            <p className="text-sm text-justify mb-1">{TerminosYCondiciones["12_planes_disponibles"].descripcion}</p>
                            <ol className="list-decimal list-outside pl-6 mb-3">
                            {TerminosYCondiciones["12_planes_disponibles"].planes.map((plan, index) => {
                                return (
                                    <li key={index} className="text-sm">{plan}</li>
                                );
                            })}
                            </ol>
                            <h1 className="text-sm font-bold">{TerminosYCondiciones["13_condiciones_pago"].titulo}</h1>
                            <p className="text-sm text-justify mb-3">{TerminosYCondiciones["13_condiciones_pago"].descripcion}</p>
                            <h1 className="text-sm font-bold">{TerminosYCondiciones["14_baja_servicio"].titulo}</h1>
                            <p className="text-sm text-justify mb-3">{TerminosYCondiciones["14_baja_servicio"].descripcion}</p>
                            <h1 className="text-sm font-bold">{TerminosYCondiciones["15_resolucion_conflictos"].titulo}</h1>
                            <p className="text-sm text-justify mb-3">{TerminosYCondiciones["15_resolucion_conflictos"].descripcion}</p>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <button onClick={handleCerrarTerminos}>Cerrar</button>
                    </DialogActions>
            </Dialog>
        )}
        </section>
    );
};

export default CotizadorPasoAPaso;